import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'ADD_TO_MANAGE_520',
    method: 'POST',
  });

  useEffect(() => {
    if (params && JSON.stringify(params) !== '{}') {
      let url = `/api/devices/${params.device_id}/crafts/${params.craft_cid}/transfer`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [exec, isRequestSuccessed];
});
